import { render, staticRenderFns } from "./ChannelGroupWeights.vue?vue&type=template&id=bff3e094&"
import script from "./ChannelGroupWeights.vue?vue&type=script&lang=js&"
export * from "./ChannelGroupWeights.vue?vue&type=script&lang=js&"
import style0 from "./ChannelGroupWeights.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports